import { useLocation, Link } from 'react-router-dom';
import { CheckCircleIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

export default function VerifyEmailPage() {
  const location = useLocation();
  const email = location.state?.email || '';

  return (
    <div className="min-h-screen flex items-center justify-center bg-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 bg-accent/10 rounded-full flex items-center justify-center">
            <EnvelopeIcon className="h-8 w-8 text-accent" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-foreground">
            Check your email
          </h2>
          <p className="mt-2 text-center text-sm text-muted-foreground">
            We've sent a verification link to{' '}
            {email && (
              <span className="font-medium text-foreground">{email}</span>
            )}
          </p>
        </div>

        <div className="bg-card rounded-lg border p-6 space-y-4">
          <div className="flex items-start space-x-3">
            <CheckCircleIcon className="h-5 w-5 text-accent mt-0.5 flex-shrink-0" />
            <div className="text-sm text-muted-foreground">
              Click the verification link in your email to activate your account
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <CheckCircleIcon className="h-5 w-5 text-accent mt-0.5 flex-shrink-0" />
            <div className="text-sm text-muted-foreground">
              Check your spam folder if you don't see the email
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <CheckCircleIcon className="h-5 w-5 text-accent mt-0.5 flex-shrink-0" />
            <div className="text-sm text-muted-foreground">
              The verification link will expire in 24 hours
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div className="text-center">
            <p className="text-sm text-muted-foreground">
              Didn't receive the email?{' '}
              <button 
                className="font-medium text-primary hover:text-primary/80"
                onClick={() => {
                  // TODO: Implement resend verification email
                  alert('Verification email resent!');
                }}
              >
                Resend verification email
              </button>
            </p>
          </div>
          
          <div className="text-center">
            <Link 
              to="/auth/login" 
              className="text-sm font-medium text-primary hover:text-primary/80"
            >
              Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
